import React, { useState } from 'react';
import { setLocalActiveClass } from "../../../utils/helper";
import './3mmguide.scss';
import { Scrollbars } from "react-custom-scrollbars";
import HomeSideMenu from '../../../components/homesidebar/homesidebar'
import HomeHeader from '../../../components/homeheader/homeheader';

class ThreeMMGuide extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
        setLocalActiveClass("HomeInstructions")
    }
    onGoClick() {
        this.props.history.push('/setreminder')
    }
    onManualClick() {
        this.props.history.push('/questionbiweekly')
    }

    render() {
        const { modalShow, setModalShow } = this.state
        return (
            <div className='main-3mmGuide'>
                <HomeSideMenu {...this.props}></HomeSideMenu>
                <HomeHeader></HomeHeader>
                <div className='inner-3mmGuide'>
                    <Scrollbars className='home-Scroll'>
                        <div className='main-Container'>
                            <div>Read More 3 MM</div>
                            {/* <Highchart></Highchart> */}
                        </div>
                    </Scrollbars>
                </div>
            </div>
        )
    }
}




export default ThreeMMGuide;

